import { render, staticRenderFns } from "./NewInitiative.vue?vue&type=template&id=5765d2f0&scoped=true"
import script from "./NewInitiative.vue?vue&type=script&lang=js"
export * from "./NewInitiative.vue?vue&type=script&lang=js"
import style0 from "./NewInitiative.vue?vue&type=style&index=0&id=5765d2f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5765d2f0",
  null
  
)

export default component.exports